// extracted by mini-css-extract-plugin
module.exports = {"content":"AddResourceDrawer_content__1f6dL","uploadText":"AddResourceDrawer_uploadText__o8fX2"};